// removed by extract-text-webpack-plugin
module.exports = {"item":"_2dt4lmgN9W5D1WMEzOCS56","image":"_1VrpFP37Gjbg4YL3H8GZbX","info":"QrscJkMcCknbs3-5cJi3b","buttons":"_1NadQBcPI_op_G0-HX8QMb","name":"_2FuUWLu48eWTJCBIjPvTpS","description":"_9DPMfGtIKHjMo6Zpt4-VV","text":"_1KR7XFqf110VYK8HrJWXQd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryItem/GalleryItem.module.scss
// module id = 769
// module chunks = 0